import 'aos/dist/aos.css'

import AOS from 'aos'
import * as React from 'react'

import { containerStyles } from '../../styles/ContainerStyles'
import { LargeSection } from '../atoms/LargeSection'
import { SectionTitle } from '../atoms/SectionTittle'
import { TextCard } from './TextCards'

export const CardGrid : React.FC = () => {

    React.useEffect(() => {
        AOS.init({
            duration: 2000
        })
    }, [])

    const style = containerStyles()
    return (
        <LargeSection backgroundColor="#161616">
            <div className={style.outerCardContainer}>
                <SectionTitle text="DER ER 5 HISTORISKE PERIODER DU SKAL BESØGE FØR DU KAN VENDE TILBAGE TIL NUTIDEN!"/>
                <div className={style.innerCardContainer}>
                    <div data-aos="fade-up">
                        <TextCard text="Tidsmaskinen skal bruge en kode for at
                              virke! Hvis I ikke får fat i koden i tide, bliver
                              I fanget i fortiden!"/>
                    </div>
                    <div data-aos="fade-down">
                        <TextCard text="Indstil tiden for at udfordre jer selv!"/>
                    </div>
                    <div data-aos="fade-up">
                        <TextCard text="Hvis du ikke klarer det inden for
                              den fastsatte tid, er I fanget i fortiden
                              til evig tid!"/>
                    </div>
                </div>
            </div>

        </LargeSection>
    )
}
